import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";
import {ViewType} from "../../../../gd/const/views/view-type";

export const MY_ATTENDANCE_CONFIG : ViewPersonalConfig = {
    type            : ViewType.MY_ATTENDANCE,
    name            : 'Attendance',
    icon            : 'i5-my-kiosk',
    iconSvg         : 'isvg-clock-in-out2',
    url             : 'clock-in-out',
    description     : 'Track your start and end work times',
    defaultLocation : PersonalViewLocation.HOME_MORE
}
